/**
 * simple class that is used to describe the
 * outcome of a validation rule
 */
export default class IsValid {
	/**
	 * @param {boolean} isValid
	 * @param {string} message
	 * @param {boolean} endAllIfInvalid
	 */
	constructor(isValid, message, endAllIfInvalid = false) {
		this.isValid = isValid;
		this.message = message;
		this.endAllIfInvalid = endAllIfInvalid;
	}
}



// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/lib/validation/IsValid.js